import React from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {ProcedureStepNumber} from 'app/procedures/components/ProcedureStepNumber';

interface Props {
  className?: string;
  n: number;
  changedState?: string;
  movedFrom?: number;
  beforeTitleContent?: JSX.Element;
  beforeStepContent?: JSX.Element;
  stepNumberContent?: JSX.Element;
  title?: JSX.Element | string;
  afterTitleContent?: JSX.Element;
  type?: 'content' | 'decision' | 'ending' | 'processprocedure';
  warnIncomplete?: boolean;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  noBottomBorder?: boolean;
}

export const ProcedureStepStructure = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      n,
      changedState,
      movedFrom,
      beforeTitleContent,
      title,
      afterTitleContent,
      stepNumberContent,
      warnIncomplete,
      type = 'content',
      noBottomBorder = false,
      beforeStepContent,
      ...other
    }: Props,
    forwardedRef
  ) => {
    return (
      <div ref={forwardedRef} {...other}>
        {beforeStepContent}
        <StyledStepContainerDIV
          className={cs(
            {
              incomplete: warnIncomplete === true,
              'border-bottom-0': noBottomBorder,
            },
            `${type}-type`
          )}
        >
          {stepNumberContent ? (
            stepNumberContent
          ) : (
            <StyledNumberContainerDiv>
              <ProcedureStepNumber
                n={n}
                type={type}
                movedFrom={movedFrom}
                changedState={changedState}
              />
            </StyledNumberContainerDiv>
          )}
          {beforeTitleContent != null ? beforeTitleContent : null}
          <h2
            style={{
              minHeight: 42,
            }}
            role="heading"
            aria-level={2}
          >
            {title}
          </h2>
          {afterTitleContent != null ? afterTitleContent : null}
        </StyledStepContainerDIV>
      </div>
    );
  }
);

export const StyledNumberContainerDiv = styled.h2.attrs({
  className: 'step-n',
})`
  position: absolute;
  top: 0;
  left: -1.75em;
  display: block;
`;

export const StyledStepContainerDIV = styled.div`
  overflow-wrap: break-word;
  position: relative;
  min-height: 4rem;
  border-bottom: 1px dotted ${colors.mediumGray};
  &.incomplete {
    .btn-link {
      color: ${colors.dangerText};
    }
    h2 {
      color: ${colors.dangerText};
    }
    .step-n {
      background-color: ${colors.dangerText};
    }
  }

  &.processprocedure-type {
    h2 {
      margin-bottom: 0;
    }
  }

  h2 .unnamed {
    opacity: 0.5;
  }
`;
